/**
 * Stable node ids for every row the tree renders.
 *
 * Each builder mirrors the ids the original monolith used, so expanded state
 * and selection targets keep working exactly as before.
 */
export const plantNodeId = (plantId) => `plant-${plantId}`;

export const wbsNodeId = (wbsId) => `wbs-${wbsId}`;

export const inputDataNodeId = (projectId, revision) =>
  `input-${projectId}-${revision}`;

export const estimationNodeId = (projectId, revision) =>
  `estimation-${projectId}-${revision}`;

export const specNodeId = (projectId) => `spec-${projectId}`;

export const revisionDocNodeId = (projectId, revision, docId) =>
  `revdoc-${projectId}-${revision}-${docId}`;

export const procurementNodeId = (plantId, categoryKey) =>
  `proc-${plantId}-${categoryKey}`;

// One row of a listed section under a plant - Project Control, Dashboard,
// AIMS, Client Data. The section key is part of the id so two sections can
// carry a row of the same name without colliding.
export const sectionItemNodeId = (plantId, sectionKey, itemKey) =>
  `sect-${plantId}-${sectionKey}-${itemKey}`;

export const procurementItemNodeId = (plantId, categoryKey, itemId) =>
  `procitem-${plantId}-${categoryKey}-${itemId}`;

export const drawingsFolderNodeId = (wbsId) => `drawings-${wbsId}`;

export const drawingNodeId = (wbsId, drawingId) =>
  `drawing-${wbsId}-${drawingId}`;
